export const conditionTypes = [
  {
    type: 'LESS_THAN',
    displayName: 'Is Less Than'
  },
  {
    type: 'LESS_THAN_OR_EQUALS',
    displayName: 'Is Less Than Or Equals'
  },
  {
    type: 'GREATER_THAN',
    displayName: 'Is Greater Than'
  },
  {
    type: 'GREATER_THAN_OR_EQUALS',
    displayName: 'Is Greater Than Or Equals'
  },
  {
    type: 'CONTAINS',
    displayName: 'Contains'
  },
  {
    type: 'DOES_NOT_CONTAIN',
    displayName: 'Does not Contain'
  },
  {
    type: 'EQUALS',
    displayName: 'Is Equal To'
  },
  {
    type: 'DOES_NOT_EQUAL',
    displayName: 'Is Not Equal To'
  },
  // {
  //   type: 'RANGE',
  //   displayName: 'Is Between'
  // },
  // Hidden as part of https://dev.azure.com/agilysys/Core/_workitems/edit/477811/
  // Added back as part of https://dev.azure.com/agilysys/Core/_workitems/edit/484335/
  {
    type: 'MATCH_REG_EX',
    displayName: 'Match (REG EX)'
  }
  // {
  //   type: IN',
  //   displayName: 'Is in a list',
  //   appliesTo: [dataTypes.STRING, dataTypes.INTEGER, dataTypes.DATE_TIME, dataTypes.DOUBLE]
  // }
];
